
import Vue from "vue";
import { api, AgentAdminView, AgentSettings } from "@/services/api";
export default Vue.extend({
    data() { return { view: null as AgentAdminView | null, settings: {} as AgentSettings, saving: false }; },
    async mounted() { await this.refresh(); },
    methods: {
        async refresh() { this.view = await api.getAgentAdmin(); if (this.view) this.settings = { ...this.view.settings }; },
        async save() { this.saving = true; try { const result = await api.updateAgentSettings(this.settings); if (result) { this.settings = result; await this.refresh(); } } finally { this.saving = false; } },
        cents(value: number): string { return `${value.toFixed(3)}c`; },
        date(value: string): string { return new Date(value).toLocaleString(); }
    }
});
